module.exports = __webpack_public_path__ + "static/media/bg_q.4ac8eb2a.png";